import type { Adventure } from '../../types'

// Age 3: Counting Animals - Fun with Farm Friends
export const countingAnimalsAdventure: Adventure = {
  id: 'counting-animals',
  title: 'Counting Farm Friends',
  theme: 'counting',
  targetAge: '3',
  difficulty: 'easy',
  estimatedDuration: 5,
  segments: {
    intro: {
      id: 'intro',
      tillyLine: "Hello friend! Welcome to the farm! Let us count some animal friends together! Are you ready?",
      duration: 4
    },
    story1: {
      id: 'story-1',
      tillyLine: "Look at these happy cows! They are mooing and playing. I wonder how many cows we can see?",
      duration: 5,
      background: 'farm-sunny'
    },
    choice1: [
      {
        id: 'count-cows',
        label: "Count the cows!",
        tillyLine: "Those cows look so friendly! Let us count them together!",
        nextState: 'quiz-1'
      }
    ],
    quiz1: {
      id: 'quiz-1',
      type: 'count-and-tap',
      question: 'Count the cows!',
      tillyPrompt: 'How many cows do you see?',
      options: [
        { id: '2', label: '2', isCorrect: false },
        { id: '3', label: '3', isCorrect: true },
        { id: '4', label: '4', isCorrect: false }
      ],
      targetNumber: 3,
      objectEmoji: '🐄'
    } as any,
    story2: {
      id: 'story-2',
      tillyLine: "Great counting! Now the sheep are waiting for us! They love being counted!",
      duration: 4,
      background: 'farm-pasture'
    },
    choice2: [
      {
        id: 'count-sheep',
        label: "Count sheep!",
        tillyLine: "The sheep say baa-baa! How many fluffy sheep can you count?",
        nextState: 'quiz-2'
      }
    ],
    quiz2: {
      id: 'quiz-2',
      type: 'count-and-tap',
      question: 'Count the sheep!',
      tillyPrompt: 'How many fluffy sheep are there?',
      options: [
        { id: '4', label: '4', isCorrect: false },
        { id: '5', label: '5', isCorrect: true },
        { id: '6', label: '6', isCorrect: false }
      ],
      targetNumber: 5,
      objectEmoji: '🐑'
    } as any,
    challenge: {
      intro: {
        id: 'challenge-intro',
        tillyLine: "You are a farm counting expert! Now for the challenge - let us count the little chicks!",
        duration: 5,
        background: 'farm-barn'
      },
      quizzes: [
        {
          id: 'challenge-1',
          type: 'count-and-tap',
          question: 'Count the chicks!',
          tillyPrompt: 'How many baby chicks are peeping?',
          options: [
            { id: '3', label: '3', isCorrect: false },
            { id: '4', label: '4', isCorrect: true },
            { id: '5', label: '5', isCorrect: false }
          ],
          targetNumber: 4,
          objectEmoji: '🐤'
        } as any
      ]
    },
    reward: {
      tillyLine: "Fantastic work! You counted all the farm animals! You are a Farm Friend Counter! Here is your badge!",
      badgeName: 'Farm Friend Counter',
      badgeIcon: '🐄',
      nextPreview: 'Next time, we will add numbers together!'
    }
  }
}

// Tilly's reactions for this adventure
export const tillyFarmCorrect = [
  "Moo-velous counting! You got it!",
  "Baa-rilliant! That is right!",
  "Oink-tastic! Perfect!",
  "Cluck-cluck correct! Amazing!",
  "You are a farm counting superstar!",
  "Woof-derful! You did it!",
  "Neigh way! You got it right!",
  "Hee-haw! Excellent counting!",
  "Purr-fect! You are so smart!",
  "Squeal with joy! You got it!"
]

export const tillyFarmWrong = [
  "Almost! Try counting again!",
  "Not quite! The animals believe in you!",
  "Good try! Let us count together!",
  "Close! Give it another go!",
  "That is okay! Farm counting is tricky!",
  "Keep trying! You will get it!",
  "The cow says moo! Try again!",
  "Almost there! One more try!",
  "You are doing great! Keep going!",
  "The sheep say you can do it!"
]

export const tillyFarmCelebration = [
  "🎉 Farm-tastic! You did it! 🎉",
  "You are the best farm counter ever! 🌟",
  "All the animals are cheering for you! 🏆",
  "Baa-rilliant work! I am so proud! 🎊",
  "Moo-velous job, farm friend! 🥇"
]
